/**
 * Columnas de la tabla breakdown. `dim` marca dimensiones (clave de
 * agrupación, sólo aparecen si están activadas en el AnalysisView).
 * El resto son métricas — siempre visibles.
 */
export const BREAKDOWN_COLS = [
  { id: 'gender', label: 'Género', type: 'text', dim: 'gender' },
  { id: 'category', label: 'Categoría', type: 'text', dim: 'category' },
  { id: 'subcategory', label: 'Subcategoría', type: 'text', dim: 'subcategory' },
  { id: 'buyUnits', label: 'Uds compra', type: 'num' },
  { id: 'sellUnitsTotal', label: 'Uds venta', type: 'num' },
  { id: 'eficacia', label: 'Eficacia', type: 'num' },
  { id: 'buyValue', label: 'Valor compra', type: 'num' },
  { id: 'sellValuePvfTotal', label: 'Valor venta (PVF)', type: 'num' },
  { id: 'rendimiento', label: 'Rendimiento', type: 'num' },
  { id: 'dto', label: 'Dto. medio', type: 'num' },
];

/**
 * Agrega filas crudas según un set de dimensiones (`gender`, `category`,
 * `subcategory`). Devuelve los grupos con métricas derivadas (eficacia,
 * rentabilidad, dto. ponderado, etc.). Usado por la tabla y los charts
 * — comparten el mismo agregado para que cuadren siempre.
 */
export const aggregateByDimensions = (rows, dimensions) => {
  const map = new Map();
  for (const r of rows || []) {
    const dimValues = {
      gender: r.gender || '—',
      category: r.category || '—',
      subcategory: r.subcategory || '—',
    };
    const key = dimensions.map((d) => dimValues[d]).join('|') || '·';
    let g = map.get(key);
    if (!g) {
      g = {
        key,
        gender: dimensions.includes('gender') ? dimValues.gender : null,
        category: dimensions.includes('category') ? dimValues.category : null,
        subcategory: dimensions.includes('subcategory') ? dimValues.subcategory : null,
        families: 0,
        buyUnits: 0,
        buyValue: 0,
        sellUnitsInSeason: 0,
        sellUnitsOutSeason: 0,
        sellUnitsTotal: 0,
        sellValuePvfInSeason: 0,
        sellValuePvfOutSeason: 0,
        sellValuePvfTotal: 0,
        sellValuePvpTotal: 0,
        pvpEtiquetaWeightedTotal: 0,
        remainUnits: 0,
        remainValueCI: 0,
      };
      map.set(key, g);
    }
    g.families += 1;
    g.buyUnits += Number(r.buyUnits) || 0;
    g.buyValue += Number(r.buyValue) || 0;
    g.sellUnitsInSeason += Number(r.sellUnitsInSeason) || 0;
    g.sellUnitsOutSeason += Number(r.sellUnitsOutSeason) || 0;
    g.sellUnitsTotal += Number(r.sellUnitsTotal) || 0;
    g.sellValuePvfInSeason += Number(r.sellValuePvfInSeason) || 0;
    g.sellValuePvfOutSeason += Number(r.sellValuePvfOutSeason) || 0;
    g.sellValuePvfTotal += Number(r.sellValuePvfTotal) || 0;
    g.sellValuePvpTotal += Number(r.sellValuePvpTotal) || 0;
    g.remainUnits += Number(r.remainUnits) || 0;
    g.remainValueCI += Number(r.remainValueCI) || 0;
    const pvp = typeof r.pvpUnit === 'number' && Number.isFinite(r.pvpUnit) ? r.pvpUnit : 0;
    g.pvpEtiquetaWeightedTotal += pvp * (Number(r.sellUnitsTotal) || 0);
  }
  return [...map.values()].map((g) => ({
    ...g,
    eficacia: g.buyUnits > 0 ? g.sellUnitsTotal / g.buyUnits : null,
    rendimiento: g.sellValuePvfTotal - g.buyValue,
    rentabilidad: g.buyValue > 0 ? (g.sellValuePvfTotal - g.buyValue) / g.buyValue : null,
    dto: g.pvpEtiquetaWeightedTotal > 0 ? 1 - g.sellValuePvpTotal / g.pvpEtiquetaWeightedTotal : null,
  }));
};
